import React, { useState, useEffect, useContext } from "react";
import EmojiEmotionsOutlinedIcon from "@material-ui/icons/EmojiEmotionsOutlined";
import ThumbUpAltOutlinedIcon from "@material-ui/icons/ThumbUpAltOutlined";
import FavoriteOutlinedIcon from "@material-ui/icons/FavoriteOutlined";
import MoreVertTwoToneIcon from "@material-ui/icons/MoreVertTwoTone";
import { StateContext } from "../reducers_component/StateProvider";
import { Button, Modal, TextArea, Form } from "semantic-ui-react";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import { Avatar } from "@material-ui/core";
import "semantic-ui-css/semantic.min.css";
import { v4 as uuidv4 } from "uuid";
import { db } from "../firebase";
import firebase from "firebase";
import "../Css/Post.css";

uuidv4();

function Post({
  postId,
  user,
  timestamp,
  username,
  caption,
  imageUrl,
  noLikes,
  postUserId,
}) {
  const [comments, setComments] = useState([]);
  const [comment, setComment] = useState("");
  const [show, setShow] = useState("like2");
  const [show2, setShow2] = useState("textforlike");
  const [posterImage, setPosterImage] = useState("");
  const [postUser, setPostUser] = useState();
  const { dispatch } = useContext(StateContext);
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    if (postUserId) {
      db.collection("users")
        .doc(postUserId)
        .onSnapshot((snapshot) => {
          setPostUser(snapshot.data());
        });
    }

    // console.log('Fuck');
  }, [postUserId]);

  useEffect(() => {
    let unsubscribe;
    if (postId) {
      unsubscribe = db
        .collection("posts")
        .doc(postId)
        .collection("comments")
        .orderBy("timestamp", "desc")
        .onSnapshot((snapshot) => {
          setComments(snapshot.docs.map((doc) => doc.data()));
        });
    }
    return () => {
      unsubscribe();
    };
  }, [postId]);

  /**
   * ! collecting all the posts and save them into firebase database!
   * ? also if someone press the like button it will show up a blue like button.
   */
  useEffect(() => {
    db.collection("posts")
      .doc(postId)
      .collection("likes")
      .doc(user.uid)
      .get()
      .then((doc2) => {
        if (doc2.data()) {
          if (show === "like2") {
            setShow("like2 blue");
            setShow2("textforlike bluetextforlike");
          } else {
            setShow("like2");
            setShow2("textforlike");
          }
        }
      });
  }, [postId, user.uid]);

  /**
   * !handle the like when someone press the like button and save data in the database.
   */
  const likeHandle = (event) => {
    event.preventDefault();
    if (show === "like2") {
      setShow("like2 blue");
      setShow2("textforlike bluetextforlike");
    } else {
      setShow("like2");
      setShow2("textforlike");
    }

    db.collection("posts")
      .doc(postId)
      .get()
      .then((docc) => {
        const data = docc.data();
        // console.log(show);
        if (show === "like2") {
          db.collection("posts")
            .doc(postId)
            .collection("likes")
            .doc(user.uid)
            .get()
            .then((doc2) => {
              if (doc2.data()) {
                console.log(doc2.data());
              } else {
                db.collection("posts")
                  .doc(postId)
                  .collection("likes")
                  .doc(user.uid)
                  .set({
                    likes: 1,
                  });
                db.collection("posts")
                  .doc(postId)
                  .update({
                    noLikes: data.noLikes + 1,
                  });
              }
            });
        } else {
          db.collection("posts")
            .doc(postId)
            .collection("likes")
            .doc(user.uid)
            .delete()
            .then(function () {
              db.collection("posts")
                .doc(postId)
                .update({
                  noLikes: data.noLikes - 1,
                });
            });
        }
      });
  };

  const postComment = (event) => {
    event.preventDefault();
    const t0 = performance.now();
    db.collection("posts").doc(postId).collection("comments").add({
      text: comment,
      username: postUser?.displayName,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      photoURL: user?.photoURL,
    });
    setComment("");
    dispatch({
      type: "ADD_TO_NOTIFICATIONS",
      item: { username: postUser?.displayName },
    });
    console.log(`postComment took`, performance.now() - t0);
  };

  useEffect(() => {
    if (postUserId) {
      db.collection("users")
        .doc(postUserId)
        .onSnapshot((snapshot) => {
          setPosterImage(snapshot.data().photoURL);
          // console.log('LoL');
        });
    }
  }, [postUserId]);

  return (
    <div
      className="post"
      key={postComment}
    >
      <div className="adit">
        <MoreVertTwoToneIcon className="editMoreAndSettings" />
      </div>
      <div className="post__header  ">
        <Avatar
          className="post_avatar"
          alt="avatar img"
          src={posterImage !== "" && posterImage}
        />
        <h4 className="h333  ">{username}</h4>

        <i className="post_verified" />
      </div>

      <h4 className="post__text" >{caption}</h4>
      <img src={imageUrl} className="post__image" alt={imageUrl} />

      <p className="timestamp  ">
        Published at <br />
        {new Date(timestamp?.toDate()).toUTCString()}
      </p>
      <div className="post__likeandlove">
        <i className="post__like" />
        <FavoriteOutlinedIcon className="post__heart" />
        <EmojiEmotionsOutlinedIcon className="post__anger" />
        <ThumbUpIcon className="iconss" />

        <p className="likep  ">
          {noLikes} {noLikes === 1 ? "Like" : "Likes"}
        </p>
      </div>

      <div className="hr" />

      <div className="post__likeoptions">
        <div className="like">
          <i className={show} />
          <h3 className={show2}>
            <ThumbUpAltOutlinedIcon
              onClick={likeHandle}
              className="like_handle_icon"
            />
            Like
          </h3>
        </div>
        <div className="comment">
          <i className="comment2" />
          <h3 className="dope">Comment</h3>
        </div>
      </div>

      <div className="hr" />
      <form onSubmit={postComment}>
        <div className="commentBox">
          <Avatar className="post__avatar2" alt="" src={user?.photoURL} />
          <Form>
            <TextArea
              placeholder="Tell us more"
              className="commentInpustBox"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            <br />
            <Button
              content="Add Comment"
              labelPosition="left"
              icon="edit"
              primary
              type="submit"
              className="add_comment"
            />

            <button
              type="submit"
              disabled={!comment}
              className="transparent__submit"
            ></button>
          </Form>
        </div>
        <p className="pressEnterToPost">Press Enter to post</p>
      </form>

      {comments.map((comment) => (
        <div
          key={uuidv4()}
          className={`comments__show ${
            comment.comment === postUser?.displayName && "myself"
          }`}
        >
          <Avatar className="post__avatar2" alt="" src={comment.photoURL} />
          <div className="container__comments">
            <p>
              <span>{comment.username}</span>
              <i class="post__verified"></i>&nbsp;{comment.text}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Post;
